import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"
import * as AuthApi from "../../../services/authApi";

export const userForgetPassword = (data, router) => async (dispatch) => {
  try {
    const response = await AuthApi.forgotPassword({
      email: data.email
    });
    
    if(data.dontNavigate) {
      return;
    }

    if(response.ok) {
        dispatch(userForgetPasswordSuccess(
            "A code for resetting your password has been sent to your email."
        ))

        router.navigate("/reset-password", {
          state: {
            email: data.email
          }
        });
    } else {
        dispatch(userForgetPasswordError(response.error))
    }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}